import NameInputPage from "./components/name-input-page"
import createComponent from "@/utils/create-component"

export default () => {
  const el = document.getElementById("vue-spaces-name-input")

  if (!el) {
    // prevent trying to mount the component when in another page
    return
  }

  const { nickname } = el.dataset

  createComponent({
    el: el,
    component: NameInputPage,
    props: {
      nickname: nickname
    }
  })
}
